export default __webpack_public_path__ + "static/media/claim-submit-success.722fa263.svg";